import React, { useEffect, useState } from "react";
import { exportFile, showError, showSuccess } from "../../../utils/utilities";
import { useTranslation } from "react-i18next";
import { Col, Modal, Row } from "antd";
import { DownloadOutlined, FileAddOutlined, WarningOutlined } from "@ant-design/icons";
import ExportBpcApi from "../../../services/api/ExportBpc";
import DetailBox from "../../../components/functional_components/DetailBox/DetailBox";
import { get, toLower } from "lodash";
import { dbDateHour, fileFormatXextension, langDateHour } from "../../../utils/properties";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import PFButton from "../../../components/functional_components/Button/PFButton";
const { confirm } = Modal;

const ExportBpc = () => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", {}));
  const dateHourFormat = langDateHour[toLower(currentLanguage)];
  const [state, setState] = useState({
    loadingGenerate: false,
    loadingDownload: false,
    infoBpc: {
      lastFileDate: null,
      working: false,
    },
  });

  useEffect(() => {
    getInfo();
  }, []);

  const getInfo = async () => {
    const { response, data } = await ExportBpcApi.exportBpcInfo();
    if (!response && data) {
      setState((prevState) => ({ ...prevState, infoBpc: data }));
    } else {
      showError(get(response?.messageCode, "error.messageCode", "ER000"));
    }
  };

  const generateBpc = async () => {
    setState((prevState) => ({ ...prevState, loadingGenerate: true }));
    confirm({
      title: t("exportBpc.confirmPopup.title"),
      icon: <WarningOutlined />,
      content: t("exportBpc.confirmPopup.content"),
      onOk: async () => {
        const { response } = await ExportBpcApi.exportBpc();
        if (!response) {
          showSuccess();
          getInfo();
        } else {
          showError(get(response?.messageCode, "error.messageCode", "ER000"));
        }
      },
    });
    setState((prevState) => ({ ...prevState, loadingGenerate: false }));
  };

  const downloadBpc = async () => {
    setState((prevState) => ({ ...prevState, loadingDownload: true }));
    const exportResponse = await ExportBpcApi.exportBpcFile();
    if (!exportResponse.error) {
      const downloadType = fileFormatXextension["xlsx"];
      const blob = new Blob([exportResponse], { type: downloadType });
      exportFile(blob, "export-bpc.xlsx");
    } else {
      showError(get(exportResponse, "error.messageCode", "ER000"));
    }
    setState((prevState) => ({ ...prevState, loadingDownload: false }));
  };

  return (
    <DetailBox title={t("exportBpc.title")}>
      <Row justify="space-between">
        <Col lg={10} className="width-100 mb-2em">
          <Row align="middle" className="mt-10">
            <Col span={4}>
              <PFButton
                isDisabled={state.infoBpc?.working}
                currentSize="large"
                isLoading={state.loadingGenerate}
                clickCallback={generateBpc}
                currentIcon={<FileAddOutlined className="icon-large" />}
              />
            </Col>
            <Col span={20} className="fw-bold">
              {state.infoBpc?.working ? t("exportBpc.working") : t("exportBpc.generate")}
            </Col>
          </Row>
        </Col>
        <Col lg={10} className="width-100 mb-2em">
          <Row align="middle" className="mt-10">
            <Col span={20} className="fw-bold">
              {t("exportBpc.downloadLast", {
                date: state.infoBpc?.lastFileDate
                  ? dayjs(state.infoBpc?.lastFileDate, dbDateHour).format(dateHourFormat)
                  : "-",
              })}
            </Col>
            <Col span={4}>
              <PFButton
                currentSize="large"
                isLoading={state.loadingDownload}
                clickCallback={downloadBpc}
                currentIcon={<DownloadOutlined className="icon-large" />}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </DetailBox>
  );
};

export default ExportBpc;
